import { BasketStatus, ReviewStatus } from 'graphql-api/baskets-api-interfaces';

export const isBasketStatusNewish = (basketStatus: BasketStatus) => {
  return [
    BasketStatus.New,
    BasketStatus.Pending,
    BasketStatus.Rejected,
  ].includes(basketStatus);
};

export const getBasketStatusToShow = (
  basketStatus: BasketStatus,
  reviewStatus: ReviewStatus,
) => {
  const isStatusNew = isBasketStatusNewish(basketStatus);
  const reviewStatusToShow = [ReviewStatus.Pending, ReviewStatus.Rejected].find(
    (possibleStatus) => possibleStatus === reviewStatus,
  );
  return isStatusNew && reviewStatusToShow
    ? reviewStatusToShow.toUpperCase()
    : basketStatus;
};
